import {
  DivRegistrationResult,
  PdfPageContent,
  buildResult,
  extractSection,
  getBlocks,
  joinPages
} from './pdfParser';

export function parsePortima(pages: PdfPageContent[]): DivRegistrationResult {
  const text = joinPages(pages);
  const blocks = getBlocks(text);

  return buildResult({
    text,
    blocks,
    policyholderSection: extractSection(text, 'VERZEKERINGNEMER', [
      'VOERTUIG',
      'BEZORGADRES'
    ]),
    vehicleBlocks: ['VOERTUIG'],
    plateLabels: ['Nummerplaat'],
    plateBlocks: ['TRANSACTIE', 'GENERAL'],
    brandLabels: ['Merk en commercieel type (D1-D3)'],
    natureLabels: ['Aard van het voertuig (J1)'],
    categoryLabels: ['Categorie', 'Carrosserietype'],
    insurerSection: blocks.VERZEKERINGSBEDRIJF || '',
    insurerLabels: ['FSMA'],
    insurerBlocks: ['VERZEKERINGSBEDRIJF'],
    dateLabels: ['Datum en tijd van de inschrijving'],
    dateBlocks: ['TRANSACTIE', 'GENERAL']
  });
}

export function isPortimaDocument(text: string): boolean {
  return (
    /\bVERZEKERINGNEMER\b/i.test(text) && /\bVERZEKERINGSBEDRIJF\b/i.test(text)
  );
}
